var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isCard)?_c('Card',{attrs:{"contractId":_vm.contractId,"cardId":_vm.cardId}}):_c('BaseContract',{attrs:{"contractId":_vm.contractId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }